import { render, staticRenderFns } from "./ModalRegistry.vue?vue&type=template&id=6cdb5152"
import script from "./ModalRegistry.vue?vue&type=script&lang=js"
export * from "./ModalRegistry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports